function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48 48V0C21.4903 0 0 21.4903 0 48H48Z",
  fill: "url(#paint0_linear_feat1)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 14,
  width: 26,
  height: 26,
  fill: "url(#paint1_linear_feat1)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_feat1",
  x1: 24,
  y1: 48,
  x2: 24,
  y2: 2.6272e-7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#99FFC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFF9E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_feat1",
  x1: 37.9792,
  y1: 26.9989,
  x2: 61,
  y2: 26.9989,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8CF2A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4DF177"
})));

var SvgFeature1 = function SvgFeature1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feature-1.83d0a2f1.svg";
export { ForwardRef as ReactComponent };